import { getCompanyFromUrl } from '../utils/company';

export interface CareerJobCard {
  id: string;
  slug: string;
  title: string;
  metaDescription: string;
  location: string;
  experienceLevel: string;
  skills: string[];
  salary: string;
  canApply: boolean;
  project?: { slug: string; title: string } | null;
}

export interface CareerProjectOverview {
  slug: string;
  title: string;
  summary: string;
  description: string;
  jobs: CareerJobCard[];
}

export interface CareerCatalogue {
  jobs: CareerJobCard[];
  projects: CareerProjectOverview[];
}

export async function readCareerContent<T>(path: string, signal: AbortSignal): Promise<T> {
  const base = import.meta.env.VITE_API_BASE_URL || 'https://ts.talenty.ai';
  const response = await fetch(`${base}/${encodeURIComponent(getCompanyFromUrl())}/career/${path}`, { signal });
  if (!response.ok) throw new Error('Die Stellen konnten nicht geladen werden.');
  return response.json();
}
